export default __webpack_public_path__ + "static/media/radio_select.41a431d2.svg";